import React, { useState, useEffect } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import AddProductModal from './AddProductModal';

const USER_PRODUCT_API = '/user-preferences/api/user-product/';

function UserProducts() {
    const [userProducts, setUserProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);


    const fetchUserProducts = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await apiClient(USER_PRODUCT_API, { method: 'GET' });
            setUserProducts(data || []);
        } catch (err) {
            console.error("خطا در دریافت لیست محصولات:", err);
            setError("خطا در بارگذاری لیست کالاها/خدمات.");
            setUserProducts([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserProducts();
    }, []);


    const handleDeleteProduct = async (dbId) => {
        if (!window.confirm("آیا از حذف این کالا/خدمت مطمئن هستید؟")) return;

        try {

            const response = await apiClient(`${USER_PRODUCT_API}`, { method: 'DELETE', data: { id: dbId } });

            if (response === '') {

                alert("کالا/خدمت با موفقیت حذف شد.");
                fetchUserProducts();
            } else {

                alert(`خطا در حذف: ${response}`);
            }
        } catch (err) {
            console.error("خطا در حذف محصول:", err);
            alert("خطا در حذف کالا/خدمت.");
        }
    };

    if (loading) {
        return <div className="text-center py-4">در حال بارگذاری کالاها/خدمات...</div>;
    }

    return (
        <div className="card stretch stretch-full">
            <div className="card-header">
                <h5 className="card-title">لیست کالاها و خدمات منتخب</h5>
                <div className="card-header-action">
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setIsModalVisible(true)}
                    >
                        <i className="feather-plus me-1"></i> اضافه کردن کالا/خدمت جدید
                    </button>
                </div>
            </div>
            <div className="card-body p-0">
                {error && <div className="alert alert-danger m-3">{error}</div>}
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th colSpan="5">نام کالا/خدمت</th>
                                <th>شناسه</th>
                                <th>نوع</th>
                                <th>درصد مالیات</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userProducts.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted">لیست کالاها/خدمات شما خالی است.</td>
                                </tr>
                            ) : (
                                userProducts.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td colSpan="5" className="text-wrap">{item.goods_and_services.name}</td>
                                        <td>{item.goods_and_services.identity}</td>
                                        <td>{item.goods_and_services.service ? 'خدمت' : 'کالا'}</td>
                                        <td>{item.goods_and_services.taxPercent}%</td>
                                        <td>
                                            <button
                                                className="btn btn-danger"
                                                onClick={() => handleDeleteProduct(item.id)}
                                            >
                                                <i className="feather-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <AddProductModal
                isVisible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                onProductAdded={fetchUserProducts}
                currentProducts={userProducts}
            />
        </div>
    );
}

export default UserProducts;